import { render, staticRenderFns } from "./work-add-buttons.vue?vue&type=template&id=1f6e80d4"
import script from "./work-add-buttons.vue?vue&type=script&lang=js"
export * from "./work-add-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports